import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { RoleApi } from 'api';
import { RoleScope } from 'types';

function useGetAll(scope: RoleScope, enabled = true) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ scope }),
    () => RoleApi.getAll(scope),
    {
      select: (data) => data.data,
      enabled,
    },
  );
}

export default useGetAll;
